import { useCallback } from 'react';

import { useOnWatchedTimeChanged } from '../../feature-player/hooks/tracker/use-on-watched-time-changed';
import { clearAutopskipTimer } from '../../feature-player/ui/skin/next-episode-skip-button-group/hooks/use-is-auto-skip-enabled';
import { cleanPlayingParams } from '../../feature-player/utils/clean-playing-params';
import { useEpisodeTvSeriesContentId } from '../ui/episode-player/hooks/use-episode-tv-series-content-id';
import { useStopPlayingContent } from '../../player-manager/helpers/stop-playing-content';

interface Props {
    contentId: string;
    onClose?: () => void;
}

export const useEpisodeHandlers = ({ contentId, onClose }: Props) => {
    const handleWatchedTimeChange = useOnWatchedTimeChanged();

    const stopPlayingContent = useStopPlayingContent();

    const tvSeriesContentId = useEpisodeTvSeriesContentId(contentId);

    const handleClose = useCallback(() => {
        clearAutopskipTimer();
        if (tvSeriesContentId) {
            onClose?.();
            cleanPlayingParams();
            stopPlayingContent();
        }
    }, [onClose, stopPlayingContent, tvSeriesContentId]);

    return { handleClose, handleWatchedTimeChange };
};
